import { Component, OnInit, ViewChild } from '@angular/core';
import { ICellRendererParams, IFloatingFilterParams } from 'ag-grid-community';
import { BehaviorSubject, Subject } from 'rxjs';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-custom-floating-filter',
  templateUrl: './custom-floating-filter.component.html',
  styleUrls: ['./custom-floating-filter.component.scss']
})
export class CustomFloatingFilterComponent implements OnInit { 
  params: IFloatingFilterParams;
  isCheck: boolean = false;
  currentValue: number;
  @ViewChild("mycheckbox") mycheckbox;
  public isChecked$ = new BehaviorSubject(false);
  private unsubscribe: Subject<void> = new Subject<void>();
  indeterminates: boolean;

constructor(private userRepositoryService: UserRepositoryService) {}

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
}

ngOnInit(): void {
  this.floatingCheckBoxValue();
}

floatingCheckBoxValue() {
  this.userRepositoryService.isRowChecked.pipe(
    takeUntil(this.unsubscribe)).subscribe(value=>{
      //console.log(value);
    //   if(value.supplierList != null && value.selectedRow > 0) {
    //   if(value.supplierList == value.selectedRow) {
    //     this.isChecked$.next(true);
    //   } else if (value.selectedRow > 0) {
    //     this.indeterminates = true;
    //   } else {
    //     this.indeterminates = false;
    //   }
    // }
      //if(value > 0){
        //   console.log(value);
        //   this.indeterminates = true;
        // } else {
        //   this.indeterminates = false;
        // }


    if(value > 0){
      this.isChecked$.next(true);
    } else {
      this.isChecked$.next(false);
    }
  });
}

toggleChecked() {
  this.isChecked$.next(!this.isChecked$.value);
  this.userRepositoryService.isChecked.next(this.isChecked$.value);
  // this.isChecked$.value == true ? this.params.api.selectAll() : this.params.api.deselectAll();
  this.isChecked$.value == true ? this.params.api.selectAllFiltered() : this.params.api.deselectAllFiltered();
}
  
refresh(params: ICellRendererParams): boolean {
  return true;
}

}
